<script>
	import Navbar from "./Navbar.svelte";
	import Section from "./Section.svelte";
	import Testimonial from "./Testimonial.svelte";
	import Footer from "./Footer.svelte";

</script>

<div class="container">
	<Navbar />
	<Section/> 
	<Testimonial/>
	<Footer/>
</div>